export const columns = [
  {
    title: '操作',
    dataIndex: 'action',
    key: 'action',
    width: 90,
    scopedSlots: { customRender: 'action' },
  },{
    title: '卡片名称',
    dataIndex: 'displayName',
    key: 'displayName',
    ellipsis: true,
    width: 596
  },{
    title: '版本',
    dataIndex: 'editionName',
    key: 'editionName',
    ellipsis: true,
    width: 399
  },{
    title: '卡片描述',
    dataIndex: 'description',
    key: 'description',
    ellipsis: true,
    width: 591
  }
]
